export type PodPositionOption = {
  value: string;
  label: string;
};

export const POD_POSITION_OPTIONS: PodPositionOption[] = [
  { value: '', label: '-- Select --' },
  { value: 'PREROLL', label: 'Pre-Roll' },
  ...Array.from({ length: 20 }, (_, i) => ({
    value: `MIDROLL_${String(i + 1).padStart(2, '0')}`,
    label: `Mid-Roll ${i + 1}`,
  })),
  { value: 'POSTROLL', label: 'Post-Roll' },
];
